import { render, staticRenderFns } from "./Pins.vue?vue&type=template&id=09ca3cc6&scoped=true"
import script from "./Pins.vue?vue&type=script&lang=ts"
export * from "./Pins.vue?vue&type=script&lang=ts"
import style0 from "./Pins.vue?vue&type=style&index=0&id=09ca3cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca3cc6",
  null
  
)

export default component.exports